import { useRouter } from 'next/router';
import queryString from 'query-string';
import { useCallback, useState } from 'react';
import Loading from '~/components/common/parts/loading/Loading';
import { Page as Component } from '~/components/specifics/todos/index/Page';
import { useCompanyDealTodos } from '~/hooks/useCompanyDealTodos';
import type { CompanyDealTodoSearchCondition } from '~/models/CompanyDealTodo';
import { normalizeSearchCondition } from '~/utils/CompanyDealTodoSearchConditionUtil';
import { PATH } from '~/pages/todos';
import { useEnabledStaffs } from '~/hooks/useStaffs';
import { useCompanyVendors } from '~/hooks/useCompanyVendors';
import useItandiAccount from '~/hooks/useItandiAccount';

export const Page: React.FC = () => {
  const router = useRouter();
  const [searchCondition, setSearchCondition] =
    useState<CompanyDealTodoSearchCondition>(
      normalizeSearchCondition(router.query)
    );
  const companyDealTodos = useCompanyDealTodos(searchCondition);
  const staffs = useEnabledStaffs().data;
  const { data: companyVendors } = useCompanyVendors().index();
  const { data: account } = useItandiAccount().currentAccount();
  const { data } = companyDealTodos;

  const updateSearchCondition = useCallback(
    (condition: CompanyDealTodoSearchCondition) => {
      setSearchCondition((prev) => {
        const newCondition = normalizeSearchCondition({
          ...prev,
          ...condition
        });

        // URLだけを書き換える
        window.history.pushState(
          '',
          '',
          `${PATH}?${queryString.stringify(newCondition, {
            arrayFormat: 'bracket'
          })}`
        );

        return newCondition;
      });
    },
    []
  );

  if (
    data === null ||
    staffs === null ||
    companyVendors === null ||
    account === null
  )
    return <Loading isLoading />;

  return (
    <Component
      companyTodos={data.objects}
      companyVendors={companyVendors}
      currentPageNum={searchCondition.page ?? 1}
      loginStaff={account.staff}
      onSearchConditionChange={updateSearchCondition}
      searchCondition={searchCondition}
      staffs={staffs}
      totalItems={data.count}
    />
  );
};
